/* eslint-disable jsx-a11y/anchor-is-valid */

// NPM libraries
import React from 'react';
import { withRouter } from 'react-router-dom';

// Semantic UI Components
import {
  Container,
  Header,
} from 'semantic-ui-react';

const Unauthorized = () => (
  <div>
    <Container text textAlign='center' style={{padding: '7.5em 0 0'}}>
      <Header as='h1'>401</Header>
      <h3>Unauthorized</h3>
      <p>Sorry, you're not authorized to view this page. Please log in.</p>
    </Container>
  </div>
);

export default withRouter(Unauthorized);
